export enum AxisEnum {
    X = 0,
    Y = 1
}